import { render, staticRenderFns } from "./PaginationOptions.vue?vue&type=template&id=f66f338e&"
import script from "./PaginationOptions.vue?vue&type=script&lang=js&"
export * from "./PaginationOptions.vue?vue&type=script&lang=js&"
import style0 from "./PaginationOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f66f338e')) {
      api.createRecord('f66f338e', component.options)
    } else {
      api.reload('f66f338e', component.options)
    }
    module.hot.accept("./PaginationOptions.vue?vue&type=template&id=f66f338e&", function () {
      api.rerender('f66f338e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/Table/PaginationOptions.vue"
export default component.exports